import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';

@Component({
  selector: 'app-subscriber',
  templateUrl: './subscriber.component.html',
  styleUrls: ['./subscriber.component.css']
})

export class SubscriberComponent implements AfterViewInit {
  @ViewChild('subscriberDiv') subscriberDiv: ElementRef;
  @Input() session: OT.Session;
  @Input() stream: OT.Stream;
  messageErreur: string;
  TITRE_POPIN = 'Erreur lors de la réception';
  PAGE_DOSSIER = '/dossier';

  constructor() {
  }

  ngAfterViewInit() {
    this.session.subscribe(this.stream, this.subscriberDiv.nativeElement, {
        insertMode: 'append',
        fitMode: 'cover',
        width: '60%',
        height: '60%'
      },
      (err) => this.messageErreur = err ? err.message : '');
  }
}



// WEBPACK FOOTER //
// ./src/app/visio/subscriber/subscriber.component.ts